import { load } from 'js-yaml';

/**
 * Extracts the title from the yaml and base yaml. If there is a subtitle, it will be appended to the title as "Title: Subtitle".
 *
 * UC courses: title may be found in `course.title` or `patches['$course.title'][0].value`, and likewise for subtitle.
 * Cl courses: titles may be found in `title` and `subtitle`.
 */
export default function extractTitle(yaml: string, baseYaml = '') {
  const title = computeValue('title', yaml, baseYaml);
  const subtitle = computeValue('subtitle', yaml, baseYaml);

  return title ? `${title}${subtitle ? `: ${subtitle}` : ''}` : '';
}

export function extractClTitle(yaml: string, baseYaml = '') {
  const title = computeClValue('title', yaml, baseYaml);
  const subtitle = computeClValue('subtitle', yaml, baseYaml);

  return title ? `${title}${subtitle ? `: ${subtitle}` : ''}` : '';
}

function computeValue(key = 'title', yaml = '', baseYaml = ''): string {
  if (!yaml) {
    return baseYaml ? computeValue(key, baseYaml) : '';
  }

  let found = '';
  try {
    const content = load(yaml || '{}') as Partial<Content>;
    const patched = content?.patches?.[`$course.${key}`]?.[0] as PatchValue;
    found = patched ? patched.value : content?.course?.[key] || '';
    // remove markdown \ new line
    found = found.replace(/ *\\?\n/g, ' ').trim();
    // remove markdown bold
    found = found.replace(/\*\*/g, '');
  } catch (e) {
    found = '';
  }

  return found || computeValue(key, baseYaml) || '';
}

function computeClValue(key = 'title', yaml = '', baseYaml = ''): string {
  if (!yaml) {
    return baseYaml ? computeClValue(key, baseYaml) : '';
  }

  let found = '';
  try {
    const content = load(yaml || '{}') as Partial<Content>;
    found = content?.[key] || '';
    found = found.replace(/ *\\?\n/g, ' ').trim();
    found = found.replace(/\*\*/g, '');
  } catch (e) {
    found = '';
  }

  return found || computeClValue(key, baseYaml) || '';
}
